export default __webpack_public_path__ + "static/1-99c5e232acca3905119ce3499a60b086.png";